module.exports = __webpack_public_path__ + "h5/img/fudan.c37707ca.png";